import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {useSnackbar} from 'notistack';
import {getRefillOrderAssets} from '../actions';
import {normaliseAsset} from '../views/PlaceOrderFlow/constants/config';

/**
 * Encapsulates the "Order Fuel" redirect decision:
 *  - single_asset user  → fetch list_asset, normalise, push to /purchase-fuel with state
 *  - multi-asset user   → push to /select-asset
 *
 * Returns { handleOrderFuel, isRedirecting }
 */
const useOrderFuelRedirect = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {enqueueSnackbar} = useSnackbar();
    const detailsOfCustomer = useSelector((state) => state?.session?.detailsOfCustomer ?? null);
    const [isRedirecting, setIsRedirecting] = useState(false);

    const handleOrderFuel = async () => {
        if (isRedirecting) return;

        if (detailsOfCustomer?.single_asset) {
            setIsRedirecting(true);
            try {
                const data = await dispatch(getRefillOrderAssets({ limit: 1, offset: 0 }));
                const rawAsset = Array.isArray(data?.results) ? data.results[0]
                    : data?.id != null ? data : null;
                if (!rawAsset) {
                    enqueueSnackbar('No Asset data found', {variant: 'error'});
                    return;
                }

                const asset = normaliseAsset(rawAsset);
                const orderType = rawAsset.last_is_pickup ? 'pickup' : 'doorstep';
                let supplier = null;

                if (asset.is_finserv_enabled) {
                    supplier = {
                        id: asset.pump_id,
                        partner_name: asset.partner_name,
                        pump_logo: asset.pump_logo,
                        pump_rate: asset.pump_rate,
                        pump_brand: null,
                        density: null,
                        is_finserv: true,
                        refueler_assigned: asset.refueler_assigned,
                    };
                }

                history.push('/place-order/purchase-fuel', { asset, supplier, orderType });
            } finally {
                setIsRedirecting(false);
            }
        } else {
            history.push('/place-order/select-asset');
        }
    };

    return { handleOrderFuel, isRedirecting };
};

export default useOrderFuelRedirect;
